const LocBlock = ({ loc }) => {
	return (
		<div className="loc-block mb-10 p-4 border border-gray-100 relative grid grid-cols-3">
			<div className="col-span-2">
				<span className="location-title text-2xl font-bold mb-3">
					{loc.name}
				</span>
				<address className="not-italic">
					{loc.address}
					{loc.address2 ? (
						<>
							<br /> {loc.address2}
						</>
					) : (
						""
					)}
					<br />
					{loc.city}, {loc.short_state} {loc.zip}
				</address>
				<a className="underline text-lg" href={`tel:${loc.phone}`}>
					{loc.phone}
				</a>
			</div>
			<div className="col-span-1 text-right">
				<div className="absolute top-5 right-4 text-xs text-gray-500">
					{loc.distance} Mi
				</div>
				<a
					href={loc.url}
					className="inline-block py-1 px-6 text-sm font-semibold rounded transition-all duration-200 capitalize eff-a__button mt-8 mb-1 border border-dark_grey text-dark_grey hover:text-primary hover:border-primary">
					Details
				</a>
			</div>
		</div>
	);
};

export default LocBlock;
